import { render, staticRenderFns } from "./ValorantRecordSections.vue?vue&type=template&id=12655b83&scoped=true"
import script from "./ValorantRecordSections.vue?vue&type=script&lang=js"
export * from "./ValorantRecordSections.vue?vue&type=script&lang=js"
import style0 from "./ValorantRecordSections.vue?vue&type=style&index=0&id=12655b83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12655b83",
  null
  
)

export default component.exports